import { Category, ICategoryArgs } from "../category/category.model";

export interface IContactTypeArgs extends ICategoryArgs {

}

export class ContactType extends Category {
    constructor(data?: IContactTypeArgs) {
        super(data);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact-type/contact-type.model.ts